const e=["prologue","resume","personal","additional","review","confirmation"];function n(t,o){return e.indexOf(t)<e.indexOf(o)}export{n as isBeforeStep,e as steps};
